var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import { Upload, Checkbox } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { v4 } from 'uuid';
import JSZip from 'jszip';
var UploadImage = /** @class */ (function (_super) {
    __extends(UploadImage, _super);
    function UploadImage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            fileList: [],
            uploadLogsChecked: true,
        };
        _this.uploadImageControler = props.uploadImageControler;
        _this.uploadImageControler &&
            _this.uploadImageControler.setUploadSuccess(_this.uploadSuccess.bind(_this));
        props.innerRef.current.getParams = _this.getParams.bind(_this);
        return _this;
    }
    UploadImage.prototype.uploadSuccess = function (data) {
        var _this = this;
        this.setState(function (state) {
            return {
                fileList: __spreadArrays(_this.state.fileList, [_this.initFileData(data)]),
            };
        });
    };
    UploadImage.prototype.initFileData = function (data) {
        return {
            uid: data.uploadId || v4(),
            name: data.name,
            status: 'done',
            url: data.downloadUrl,
            size: data.size,
            type: data.type,
        };
    };
    UploadImage.prototype.beforeUpload = function (_file, _fileList) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.uploadImageControler && this.uploadImageControler.addFile(_file);
                return [2 /*return*/];
            });
        });
    };
    UploadImage.prototype.customRequest = function () {
        return;
    };
    UploadImage.prototype.removeFileItem = function (data) {
        this.setState({
            fileList: this.state.fileList.filter(function (i) { return i.uid !== data.uid; }),
        });
        return true;
    };
    UploadImage.prototype.uploadLogsCheckedChange = function (e) {
        this.setState({
            uploadLogsChecked: e.target.checked,
        });
    };
    UploadImage.prototype.getLogsUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var zip, content, userName, currentDate, logFile, state;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        zip = new JSZip();
                        this.props.logFiles.forEach(function (item) {
                            zip.file(item.name, item.blob, { binary: true });
                        });
                        return [4 /*yield*/, zip.generateAsync({
                                type: 'blob',
                                compression: 'DEFLATE',
                                compressionOptions: {
                                    level: 9,
                                },
                            })];
                    case 1:
                        content = _a.sent();
                        userName = this.props.userData.realName;
                        currentDate = new Date().getTime();
                        logFile = new File([content], "logs-" + userName + "-" + currentDate + ".zip");
                        return [4 /*yield*/, (this.uploadImageControler &&
                                this.uploadImageControler.asyncAddFile(logFile))];
                    case 2:
                        state = _a.sent();
                        return [2 /*return*/, [this.initFileData(state)].map(function (i) { return i.url; })];
                }
            });
        });
    };
    UploadImage.prototype.getParams = function () {
        return __awaiter(this, void 0, void 0, function () {
            var logUrl, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.state.uploadLogsChecked) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getLogsUrl()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = [];
                        _b.label = 3;
                    case 3:
                        logUrl = _a;
                        return [2 /*return*/, {
                                pictures: this.state.fileList.map(function (i) { return i.url; }),
                                logs: logUrl,
                            }];
                }
            });
        });
    };
    UploadImage.prototype.render = function () {
        var fileList = this.state.fileList;
        var uploadButton = (React.createElement("div", null,
            React.createElement(PlusOutlined, null),
            React.createElement("div", { style: { marginTop: 8 } }, "\u4E0A\u4F20\u56FE\u7247")));
        var progress = {
            strokeColor: {
                '0%': '#108ee9',
                '100%': '#87d068',
            },
            strokeWidth: 3,
            format: function (percent) { return parseFloat(percent.toFixed(2)) + "%"; },
        };
        return (React.createElement("div", { className: "feedback-upload" },
            React.createElement(Upload, { listType: "picture-card", accept: "image/*", fileList: fileList, beforeUpload: this.beforeUpload.bind(this), progress: progress, customRequest: this.customRequest.bind(this), onRemove: this.removeFileItem.bind(this) }, fileList.length >= 5 ? null : uploadButton),
            !this.props.isHiddenSelectLog && (React.createElement(Checkbox, { onChange: this.uploadLogsCheckedChange.bind(this), checked: this.state.uploadLogsChecked }, "\u4E0A\u4F20\u65E5\u5FD7\uFF1A\u7CFB\u7EDF\u65E5\u5FD7\u7528\u4E8E\u4EA7\u7814\u56E2\u961F\u6392\u67E5\u95EE\u9898"))));
    };
    return UploadImage;
}(React.Component));
export default UploadImage;
//# sourceMappingURL=UploadIamge.js.map